/** EHR registry deep-link for a building's registry code (falls back to the index). */
export function ehrUrlFor(registryCode: string | null | undefined) {
  return registryCode
    ? `https://livekluster.ehr.ee/ui/ehr/v1/building/${registryCode}`
    : "https://livekluster.ehr.ee/ui/ehr/v1/building";
}

/**
 * True when a source name identifies Ehitisregister itself — an empty
 * `api_building_data.source_system` (the only registry we read today) or its
 * name. That column is free text, so another registry can appear there: only
 * Ehitisregister may be rendered as the `EhrChip` deep-link, because the link
 * would otherwise point at a registry that never reported the value.
 */
export function isEhrRegistryName(name: string | null | undefined): boolean {
  const normalized = name?.trim().toLowerCase() ?? "";
  return normalized === "" || normalized === "ehr" || normalized === "ehitisregister";
}
